
import { defineComponent, PropType } from 'vue'

export interface FilterChoice {
  name: string
  label: string
  icon: string
  iconColor?: string
}

/**
 * Common filter component to filter items.
 */
export default defineComponent({
  name: 'FilterGeneric',

  props: {
    selectedFilter: {
      type: String,
      default: ''
    },
    filters: {
      type: Object as PropType<Record<string, FilterChoice>>,
      required: true
    },
    badgeSize: {
      type: String,
      default: 'md'
    },
    triggerLabel: {
      type: String,
      default: 'Filter'
    }
  },

  computed: {
    filterApplied(): boolean {
      return Boolean(this.filters[this.selectedFilter])
    },
    filterLabel(): string {
      return this.filters[this.selectedFilter]?.label ?? ''
    },
    filterIcon(): string {
      return this.filters[this.selectedFilter]?.icon ?? ''
    },
    filterIconColor(): string {
      return this.filters[this.selectedFilter]?.iconColor ?? ''
    }
  },

  methods: {
    updateFilterAndToggle(filter: string, close: () => void): void {
      this.$emit('update-filter', filter)
      this.$emit('menu-toggle')
      close()
    }
  }
})
